export const BYOGG_URL = 'https://byo.gg'

export const SHORT_ID_LENGTH = 10
